const Isotope = require("isotope-layout");

// Provide an array of images here
import { FsiGlightboxGallery } from "CompLib/services/os-fancybox";

// description true will display alt-attribute under the image

import "./styles.scss";

// init normal iwara

class IwaraImageFancyRawImgSize {
  constructor() {
    if (!document.querySelectorAll(".iwara-image-fancy-raw-img-size")) return;
    this.imageWraps = [...document.querySelectorAll(".iwara-image-fancy-raw-img-size .img-wrp")];
    this.initIsotope();
    this.fancyBoxes = new FsiGlightboxGallery(this.imageWraps, { description: false, loop: true });
    window.fancyBoxes = this.fancyBoxes;
    this.addEvents();
    this.grid;
  }
  initIsotope = () => {
    this.grid = new Isotope(".iwara-image-fancy-raw-img-size", {
      percentPosition: true,
      itemSelector: ".iwara-image-fancy-raw-img-size .specItem",
      masonry: {
        columnWidth: ".grid-sizer",
        gutter: ".gutter-sizer",
      },
    });
    this.grid.once("layoutComplete", () => {
      lazySizes.autoSizer.checkElems();
      this.grid.layout();
    });
  };
  addEvents = () => {
    document.querySelector(".iwara-image-fancy-raw-img-size").addEventListener("lazyloaded", this.reLayout);
  };
  removeEvents = () => {
    document.querySelector(".iwara-image-fancy-raw-img-size").removeEventListener("lazyloaded", this.reLayout);
  };
  destroy = () => {
    this.grid.destroy();
    this.removeEvents();
    this.fancyBoxes.destroy();
  };
  reLayout = () => {
    this.grid.layout();
  };
}

export { IwaraImageFancyRawImgSize };
